import { useEffect } from "react";

const useDwellTimeTracking = () => {
  useEffect(() => {
    let engaged = true;
    let timeSpent = 0;
    const intervalTime = 10000; // 10 seconds

    const sendEngagementEvent = (seconds) => {
      window.trackGoogleAnalyticsEvent('active_time', {
        duration: seconds * 1000,
      });
    };

    const sendExitEvent = (seconds) => {
      window.trackGoogleAnalyticsEvent('exit_intent', {
        time_on_page: seconds * 1000,
        page_path: window.location.pathname,
      });
    };

    const track = () => {
      if (engaged) {
        timeSpent += intervalTime / 1000;
        sendEngagementEvent(timeSpent);
      }
    };

    const interval = setInterval(track, intervalTime);

    // Detect inactivity
    let activityTimeout;
    const resetActivity = () => {
      engaged = true;
      clearTimeout(activityTimeout);
      activityTimeout = setTimeout(() => {
        engaged = false;
      }, 30000); // 30s of no activity = inactive
    };

    ['mousemove', 'keydown', 'scroll', 'touchstart'].forEach(event =>
      window.addEventListener(event, resetActivity)
    );

    resetActivity();

    const handleExit = () => {
      clearInterval(interval);
      sendExitEvent(timeSpent);
    };

    window.addEventListener('beforeunload', handleExit);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        handleExit();
      }
    });

    return () => {
      clearInterval(interval);
      window.removeEventListener('beforeunload', handleExit);
      document.removeEventListener('visibilitychange', handleExit);
      ['mousemove', 'keydown', 'scroll', 'touchstart'].forEach(event =>
        window.removeEventListener(event, resetActivity)
      );
    };
  }, []);
};

export default useDwellTimeTracking;
